import React, { useState, useEffect } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import MainLayout from "../../components/Common/MainLayout/MainLayout";
import { organize } from "../../utils/mainTabs/organize/organize";
import { topicManagement } from "../../utils/mainTabs/organize/topicManagement";
import { seriesManagement } from "../../utils/mainTabs/organize/seriesManagement";
import { addGroupTopic } from "../../utils/mainTabs/organize/addGroupTopic";
import { addNewTopic } from "../../utils/mainTabs/organize/addNewTopic";
import CreateNewSeries from "./SeriesManagement/CreateNewSeries/CreateNewSeries";
import { addSeriesMgmt } from "../../utils/mainTabs/organize/addSeriesMgmt";
import { tileTypes } from "../../utils/tileTypes";
import { tileSize } from "../../utils/tileSizes";
import { useSelector } from "react-redux";
import { roleMenuList } from "../../utils/roleMenuList";
import { featureList } from "../../utils/featureList";

const OrganizePage = () => {
  const { tenantName } = useOutletContext();
  const navigate = useNavigate();
  const location = useLocation();
  const routerParams = useParams();
  const [organizeHeader, setOrganizeHeader] = useState();
  const [organizeButtons, setOrganizeButtons] = useState([]);
  const [groupTopicNavLinks, setgroupTopicNavLinks] = useState([]);
  const [groupTopicTiles, setGroupTopicTiles] = useState([]);
  const [seriesTileType, setSeriesTileType] = useState(tileTypes.DEFAULT);
  const [organizeTileSize, setOrganizeTileSize] = useState(tileSize.LARGE);
  const { topicName, seriesName, path, buttons } = organize;
  const { navLinks: groupNavLinks, tiles: groupTiles } = addGroupTopic;
  const { navLinks: newTopicNavLinks, tiles: newTopicTiles } = addNewTopic;
  const { navLinks: seriesMgmtNavLinks, tiles: seriesMgmtTiles } =
    addSeriesMgmt;
  const commonState = useSelector((state) => state.commonReducer);
  const { userRoleMenu, myProfile } = commonState;
  const createGroupTopicPath = addGroupTopic.path(
    location,
    routerParams,
    tenantName
  );
  const createGroupTopicEditPath = addGroupTopic.editpath(tenantName);
  const createNewTopicPath = addNewTopic.path(
    location,
    routerParams,
    tenantName
  );
  const topicEditPath = addNewTopic.editpath(tenantName);
  const createNewSeriesPath = addSeriesMgmt.path(
    location,
    routerParams,
    tenantName
  );
  const organizePath = path(tenantName);
  const topicMgmtPath = topicManagement.path(tenantName);
  useEffect(() => {
    if (location.pathname === topicMgmtPath) {
      let buttonList = buttons(navigate, tenantName);
      setOrganizeButtons(buttonList);
      setOrganizeHeader(topicName);
      setGroupTopicTiles([]);
    } else if (location.pathname === seriesManagement.path(tenantName)) {
      let buttonList = buttons(navigate, tenantName);
      setOrganizeButtons(buttonList);
      setOrganizeHeader(seriesName);
      setGroupTopicTiles([]);
    } else if (location.pathname.includes(createGroupTopicPath)) {
      let grpTopicNavLinks = groupNavLinks(navigate, tenantName, location);
      // let grpTiles = groupTiles;
      setOrganizeButtons([]);
      setOrganizeHeader("");
      setgroupTopicNavLinks(grpTopicNavLinks);
      // setGroupTopicTiles(grpTiles);
    } else if (location.pathname.includes(createNewTopicPath)) {
      let newTpcNavLinks = newTopicNavLinks(navigate, tenantName, location);
      // let newTpcTiles = newTopicTiles;
      setOrganizeButtons([]);
      setOrganizeHeader("");
      setgroupTopicNavLinks(newTpcNavLinks);
      // setGroupTopicTiles(newTpcTiles);
    } else if (
      location.pathname.includes(createNewSeriesPath) ||
      location.pathname.includes(addSeriesMgmt.copypath(tenantName))
    ) {
      let seriesNavLinks = seriesMgmtNavLinks(navigate, tenantName, location);
      // let seriesTiles = seriesMgmtTiles;
      setSeriesTileType(tileTypes.DEFAULT);
      setOrganizeButtons([]);
      setOrganizeHeader("");
      setgroupTopicNavLinks(seriesNavLinks);
      // setGroupTopicTiles(seriesTiles)
    }
  }, [
    location,
    buttons,
    navigate,
    tenantName,
    createGroupTopicPath,
    routerParams,
    topicMgmtPath,
  ]);
  const checkMSOMFeature = (menu, isMSOMFeatuePresent) => {
    myProfile?.TenantFeatures?.forEach((item) => {
      if (menu[0]?.MSOMMenu === item?.Name) isMSOMFeatuePresent = true;
    });
    return isMSOMFeatuePresent;
  };
  useEffect(() => {
   if(location.pathname === organizePath){
    navigate(topicMgmtPath)
   }
  }, [organizePath])
  
  useEffect(() => {
    if (location.pathname === organizePath) {
      if (myProfile?.TenantFeatures) {
        let isMSOMFeatuePresent = false;
        isMSOMFeatuePresent = checkMSOMFeature(
          [
            {
              roleMenu: roleMenuList?.ORGANIZE?.TOPIC_MANAGEMENT,
              MSOMMenu: featureList?.TOPIC_MGMT,
            },
          ],
          isMSOMFeatuePresent
        );
        if (isMSOMFeatuePresent) navigate(topicMgmtPath);
        else navigate(seriesManagement?.path(tenantName));
      }
    }
  }, [
    location,
    topicMgmtPath,
    organizePath,
    navigate,
    tenantName,
    userRoleMenu,
    myProfile?.TenantFeatures,
    checkMSOMFeature
  ]);
  return (
    <MainLayout
      heading={organizeHeader}
      navLinks={groupTopicNavLinks}
      buttons={organizeButtons}
      tiles={groupTopicTiles}
      tileType={seriesTileType}
      tileSize={organizeTileSize}
      isStepTile
    >
      <Outlet
        context={{
          groupTopicTiles,
          setGroupTopicTiles,
          seriesMgmtTiles,
          createNewSeriesPath,
          createNewTopicPath,
          createGroupTopicPath,
          createGroupTopicEditPath,
          topicEditPath,
          tenantName,
        }}
      ></Outlet>
    </MainLayout>
  );
};

export default OrganizePage;
